
import Vue from "vue";
import { Auth } from "aws-amplify";
import ImageIcon from "@/components/atoms/ImageIcon.vue";
import { News } from "@/lib/models/general";
import { NotificationsFromNolaNovel } from "@/lib/models";
import { NolaAnalytics, NolaItemId } from "@/lib/utils/analytics";

export default Vue.extend<Data, Methods, Computed, {}>({
  components: { ImageIcon },
  data() {
    return {
      isLoggedIn: null as boolean | null,
    };
  },
  async created() {
    try {
      const user = (await Auth.currentCredentials()) as any;
      this.isLoggedIn = user && !user.code && user.authenticated;
    } catch {
      this.isLoggedIn = false;
    }
  },
  computed: {
    showHeader() {
      const authType = this.$route.meta?.authType;
      // 認証必須ページの場合、ルーターガードが認証済みを保証するため常に表示
      if (authType === "require_auth") return true;
      // 認証不要ページ（authType: null）の場合、ログイン状態に基づいて表示
      return this.isLoggedIn === true;
    },
    isActivePath() {
      return (name, excludePath) => {
        const { path } = this.$route;
        if (excludePath && path.startsWith(excludePath)) {
          return false;
        }
        return path.startsWith(name);
      };
    },
    isUnread() {
      const { latestNews, readLatestNews } = this;
      if (latestNews && readLatestNews) {
        return latestNews.updatedAt !== readLatestNews.updatedAt;
      }
      return true;
    },
    latestNews() {
      return this.$store.getters["generalModule/latestNews"];
    },
    readLatestNews() {
      return this.$store.getters["generalModule/readLatestNews"];
    },
    isUnreadFromNolaNovel() {
      const unreadNotifications = this.$store.getters["nolaNovelModule/notifications"](
        false
      ) as NotificationsFromNolaNovel;
      return unreadNotifications.items.length > 0;
    },
    hasUnreadAgentNotifications() {
      const notificationSummary = this.$store.getters["notificationModule/notificationSummary"];
      return notificationSummary?.unreadItemCount > 0;
    },
    hasUnreadInbox() {
      // エージェント通知またはNolaノベル通知に未読があれば表示
      return this.hasUnreadAgentNotifications || this.isUnreadFromNolaNovel;
    },
    isNolanovelOrAgentPath() {
      const { path } = this.$route;
      return path.startsWith("/nolanovel") || path.startsWith("/agent");
    },
  },
  methods: {
    onClickLink(name) {
      this.$gtm.trackEvent({
        event: "click_header_link",
        value: name,
      });
    },
    onClickInbox() {
      const nolaAnalytics = new NolaAnalytics(this.$gtm, this.$store);
      nolaAnalytics.logButtonEvent(NolaItemId.HeaderInboxClick);
    },
  },
});

interface Data {
  isLoggedIn: boolean | null;
}

interface Computed {
  showHeader: boolean;
  isActivePath(name: string, excludePath?: string): boolean;
  isUnread: boolean;
  latestNews: News;
  readLatestNews: News;
  isUnreadFromNolaNovel: boolean;
  hasUnreadAgentNotifications: boolean;
  hasUnreadInbox: boolean;
  isNolanovelOrAgentPath: boolean;
}

interface Methods {
  onClickLink(name: string): void;
  onClickInbox(): void;
}
